import React from 'react'
import { t } from 'ttag'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { Icon, SettingsIcon } from 'components/shared/Icon/Icon'

import styles from './Admin.module.scss'

export const Admin = ({ onClickAdmin }) => (
  <Dropdown.MenuItem className={styles.admin}>
    <Dropdown.Action className={styles.action} onClick={onClickAdmin}>
      <Icon className={styles.icon} icon={SettingsIcon} size={20} />
      <span>{t`Django admin`}</span>
    </Dropdown.Action>
  </Dropdown.MenuItem>
)
